var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.331 5.54034C15.4364 5.70231 15.6166 5.8 15.8098 5.8H18.4286C18.7442 5.8 19 6.05584 19 6.37143V6.42857C19 6.74416 18.7442 7 18.4286 7H5.57143C5.25584 7 5 6.74416 5 6.42857V6.37143C5 6.05584 5.25584 5.8 5.57143 5.8H8.19017C8.38343 5.8 8.5636 5.70231 8.66905 5.54035L9.50284 4.25965C9.60829 4.09769 9.78846 4 9.98172 4H14.0183C14.2116 4 14.3918 4.09769 14.4972 4.25966L15.331 5.54034ZM8.24119 20C7.20023 20 6.3487 19.2105 6.3487 18.2453V8.70051C6.3487 8.38492 6.60454 8.12908 6.92013 8.12908H17.1321C17.4477 8.12908 17.7035 8.38492 17.7035 8.70051V18.2453C17.7035 19.2105 16.852 20 15.8111 20H8.24119ZM9 11.5C9 11.2239 9.22386 11 9.5 11C9.77614 11 10 11.2239 10 11.5V16.5C10 16.7761 9.77614 17 9.5 17C9.22386 17 9 16.7761 9 16.5V11.5ZM15 11.5C15 11.2239 14.7761 11 14.5 11C14.2239 11 14 11.2239 14 11.5V16.5C14 16.7761 14.2239 17 14.5 17C14.7761 17 15 16.7761 15 16.5V11.5Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.5e8a587f67c8804616a1662525dcea31.svg";
export { ForwardRef as ReactComponent };